import { StatusBar } from '../../cdl/StatusBar/StatusBar';
import { translate } from '../../common/helpers/translate.helper';
import { IconClock } from '../../common/icons/cdl/Clock';
import { OverlayHeader } from '../../common/Overlay/OverlayHeader';

import { ApprovalRequestContentContainer } from './ApprovalRequestContentContainer';

const UnauthorizedStatusStatusBar = () => {
    const headline = translate('approvalRequest.statusBar.unauthorizedError.headline');
    const subHeadline = translate('approvalRequest.statusBar.unauthorizedError.subHeadline');

    return <StatusBar variant="negative" headline={headline} subHeadline={subHeadline} leadingVisual={<IconClock />} />;
};

export const UnauthorizedError = () => {
    return (
        <OverlayHeader>
            <ApprovalRequestContentContainer>
                <UnauthorizedStatusStatusBar />
            </ApprovalRequestContentContainer>
        </OverlayHeader>
    );
};
